import React from 'react'
import CoordinatorMomentAttendance from '../../features/coordinator/CoordinatorMomentAttendance'

const CoordinatorMomentAttendancePage = () => {
  return <CoordinatorMomentAttendance/>
}

export default CoordinatorMomentAttendancePage